module.exports = __webpack_public_path__ + "static/media/entregador.ff15bbb6.png";